import { FC, useState, useEffect, useRef, useId } from "react";
import s from "./ModalAddCollection.module.scss";
import { useDispatch } from "react-redux";
import { Close } from "../../../assets/svg/Close";
import { addOrUpdateAttribute, changeShowModal } from "../../../redux/actions";
import { InputWrapper } from "../../../shared/InputWrapper/InputWrapper";
import { ButtonWrapper } from "../../../shared/ButtonWrapper/ButtonWrapper";
import { popUp } from "../../../features/popUp/PopUp";
import updateAttributeApi from "../../api/attributes/updateAttributeApi";
import createAttributeApi from "../../api/attributes/createAttributeApi";
import { optionsTag } from "../../../utils/constants";

type ModalAddCollectionT = {
  closeFunc: any;
  data: any;
};
export const ModalAddCollection: FC<ModalAddCollectionT> = ({ ...props }) => {
  const { closeFunc, data } = props;
  const { prjectId, id, name } = data;
  const text = id ? "Edit collection" : "Add new collection";
  const wrapperRef: any = useRef(null);
  const dispatch = useDispatch();
  const [nameValue, setNameValue] = useState(name);
  const errorsIfNullValue = [
    {
      value: nameValue,
      message: "The name field must not be empty",
    },
  ];

  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      "mousedown",
      handleClickOutside(wrapperRef, closeFunc)
    );
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside(wrapperRef, closeFunc)
      );
    };
  }, [wrapperRef]);

  async function addOrEditAttribute() {
    dispatch(changeShowModal({ nameModal: "loader", stateModal: true }));
    let errorCounter: number = 0;
    errorsIfNullValue.map((error: any) => {
      if (!error.value) {
        errorCounter++;
        popUp({ type: "failure", message: error.message });
      }
    });

    if (errorCounter === 0) {
      // редагуємо
      if (id) {
        const updatedOption = await updateAttributeApi({
          id: id,
          values: { name: nameValue },
          url: optionsTag["collections"].update.url,
          request: optionsTag["collections"].update.request,
        });
        if (updatedOption) {
          dispatch(
            addOrUpdateAttribute({
              attrId: updatedOption.id,
              attrName: "collections",
              attrValue: updatedOption,
              type: "update",
            })
          );

          popUp({
            type: "success",
            message: "collections updated!",
          });
        }
      } else {
        // створюємо

        const newAttr = await createAttributeApi({
          values: {
            name: nameValue,
            projectId: prjectId,
          },
          url: optionsTag["collections"].create.url,
          request: optionsTag["collections"].create.request,
        });
        if (newAttr) {
          dispatch(
            addOrUpdateAttribute({
              attrId: newAttr.id,
              attrName: "collections",
              attrValue: {
                ...newAttr,
                items: [],
              },
              type: "add",
            })
          );
          popUp({
            type: "success",
            message: "collection has been successfully created",
          });
        }
      }
      // const projects = await getProjectsApi();
      // dispatch(setAllProjects({ projects: projects.rows }));
      closeFunc();
    }
    dispatch(changeShowModal({ nameModal: "loader", stateModal: false }));
  }

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <div className={s.head}>
        <span>{text}</span>
        <div className={s.close} onClick={closeFunc}>
          <Close />
        </div>
      </div>
      <div className={s.content}>
        <InputWrapper
          name="name"
          setValue={setNameValue}
          value={nameValue}
          type="text"
          isRequired={true}
          placeholder="Enter name"
        />

        <ButtonWrapper
          clickEvent={addOrEditAttribute}
          text="Save collection"
          type="primary"
        />
      </div>
    </div>
  );
};
